import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { useFormik } from "formik";
import * as Yup from "yup";
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { countryCodeData as options } from '../../../Utils/countyCodeMapping';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import {getCode} from '../../../Utils/googleApi';
import {EditData} from "../../../modules/Apis/Pharmacy/Profile/Profile";
import {logOut} from "../../../modules/Auth/Logout";
import FileUpload from '../../../Utils/Components/FileUpload';
import {ErrorToast} from "../../../modules/Toast/ErrorSnakBar";
import {SuccessToast} from "../../../modules/Toast/SuccessSnackBar";
import Spinner from "../../../Utils/Components/CustomSpinner";
import { ImageLoad } from "../../../Utils/Components/ImageLoad";
import {currencyCodeData} from '../../../Utils/currencyCodeMapping';
import getSymbolFromCurrency from 'currency-symbol-map'
import { DatePickerField } from "./../../../../_metronic/_partials/controls/forms/DatePickerField";



const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

const gstinRegex = new RegExp(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/)

export default function Details(props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false)
  const data = props.data
  let intValues = {
    pharmacy_name:data.pharmacy_name,
    country_code:data.user.country_code,
    mobile_number:data.user.mobile_number,
    email:data.user.email,
    alt_mobile_number:data.alt_mobile_number,	
    alt_country_code:data.alt_country_code,
    gstin:data.gstin	,
    payout_period: data.payout_period,


    dl_number:data.dl_number	,
    dl_issuing_authority:data.dl_issuing_authority	,
    dl_date_of_issue:data.dl_date_of_issue	,
    dl_valid_upto:data.dl_valid_upto,
    dl_file:data.dl_file,
    upload_dl:'',

    pharmacist_name:data.pharmacist_name	,
    pharmacist_reg_number:data.pharmacist_reg_number	,
    reg_date:data.reg_date	,
    reg_valid_upto:data.reg_valid_upto,
    course:data.course,
    issuing_authority:data.issuing_authority	,
    reg_certificate:data.reg_certificate,
    upload_reg:'',


    pincode:data.address[0].pincode,
    street_name:data.address[0].street_name,
    city_village:data.address[0].city_village,
    district:data.address[0].district,
    state:data.address[0].state,
    country:data.address[0].country,
    home_delivery:String(data.home_delivery),
    order_amount:data.order_amount,
    latitude:data.address[0].latitude,
    longitude:data.address[0].longitude,
    currency_code:data.user.currency_code,

    bank_account_number:data.bank_account_details[0].bank_account_number,
    bank_account_holder:data.bank_account_details[0].bank_account_holder,
    bank_name:data.bank_account_details[0].bank_name	,
    bank_city:data.bank_account_details[0].bank_city,
    bank_ifsc:data.bank_account_details[0].bank_ifsc,
    bank_account_type:data.bank_account_details[0].bank_account_type,
  }

  if (intValues.course !== 'D.Pharm' && intValues.course !== 'B.Pharm' && intValues.course !== 'Pharm.D') {
    intValues['course'] = 'Others'
    intValues['course_name'] = data.course
  }

  if (intValues.alt_mobile_number == null) {
    intValues['alt_mobile_number'] = ''
  }

  if (intValues.currency_code == null) {
    intValues['currency_code'] = 'INR'
  }

    
      const ifsc_code = new RegExp(/^[A-Za-z]{4}[a-zA-Z0-9]{7}$/)

      const dlRef = React.useRef(null) 

    const formik = useFormik({
      initialValues: intValues,
      validationSchema: Yup.object({
        pharmacy_name: Yup.string()
          .required("Pharmacy name is Required!"),
        email: Yup.string()
          .email("Invalid email format")
          .required("Email is Required!"),
        gstin: Yup.string()
          .matches(gstinRegex, "Must be a standard gst number.")
          .max(15, 'Must be 15 characters.')
          .min(15, 'Must be 15 characters.')
          .required('GSTIN number field is required '),
        dl_number: Yup.string()
          .required("DL number is Required!"),
        dl_issuing_authority: Yup.string()
         .required("DL issuing authority is Required!"),
        dl_date_of_issue: Yup.date('Must be a valid date')
          .nullable()
          .max(new Date(), 'Date of issue cannot be a future date' )
          .required('The Date of issue field is required.'),
        dl_valid_upto: Yup.date('Must be a valid date')
          .nullable()
          .min(new Date(), "Date must be in the future")
          .required('The Date of validity field is required.'),
          pharmacist_name: Yup.string()
            .required("Pharmasist name is Required!"),
          course: Yup.string()
           .required("Course is Required!"),
          course_name: Yup.string().when('course', {
            is: 'Others',
            then: Yup.string().required('Course name is required')
          }),
          pharmacist_reg_number: Yup.string()
            .required("Register number Required!"),
          reg_date: Yup.date('Must be a valid date')
            .nullable()
            .max(new Date(), 'Date of issue cannot be future dates' )
            .required('The Date of issue field is required.'),
          reg_valid_upto: Yup.date('Must be a valid date')
            .nullable()
            .min(new Date(), "Date must be in the future")
            .required('The Date of validity field is required.'),
          issuing_authority: Yup.string()
            .required("Issuing authority is Required!"),
          alt_mobile_number: Yup.string()
          .max(10, 'Invalid phone number')
          .min(10, 'Invalid phone number')
          .nullable()
          ,
          mobile_number: Yup.string()
          .required('Mobile number is required')
          .max(10, 'Invalid phone number')
          .min(10, 'Invalid phone number')
          .nullable()
          ,
          // bank_account_number: Yup.string()
          //   .required("Account number is Required!"),
          // bank_account_holder: Yup.string()
          //   .required("Account holder name is Required!"),
          // bank_name: Yup.string()
          //   .required("Bank name is Required!"),
          // bank_city: Yup.string()
          //  .required("Bank city is Required!"),
          // bank_ifsc: Yup.string()
          // .matches(ifsc_code, 'Must be a valid IFSC code')
          // .required('The IFSC field is required.'),
          pincode: Yup.string()
          .matches(/^[0-9]*$/, 'Invalid Pincode')
          .required("Pincode is Required!")
          .test('len', 'Invalid Pincode', val => val.length === 6)
          .nullable(),
          country: Yup.string()
           .required("Country is Required!"),
          state: Yup.string()
            .required("State is Required!"),
          district: Yup.string()
            .required("District is Required!"),
          city_village: Yup.string()
            .required("City/Village/Society is Required!"),
          street_name: Yup.string()
           .required("Area/Street/Sector is Required!"),
      }),
      onSubmit: values => {
        console.log(values);
        setLoading(true)
        props.setLoading(true)
        const data = values
        data['mobile_number'] = String(values.mobile_number)
        if (values.course !== 'Others'){
          data["course"] = values.course
      } else {
          data["course"] = values.course_name
      }

        
        let formData = new FormData();
        formData.append('pharmacy_name', values.pharmacy_name)
        formData.append('country_code', values.country_code)
        formData.append('mobile_number', String(values.mobile_number))
        formData.append('email', values.email)
        formData.append('gstin', values.gstin)
        formData.append('dl_number', values.dl_number)
        formData.append('dl_issuing_authority', values.dl_issuing_authority)
        formData.append('dl_date_of_issue', values.dl_date_of_issue)
        formData.append('dl_valid_upto', values.dl_valid_upto)
        formData.append('dl_file', values.upload_dl)
        formData.append('pincode', values.pincode)
        formData.append('street_name', values.street_name)
        formData.append('city_village', values.city_village)
        formData.append('district', values.district)
        formData.append('state', values.state)
        formData.append('country', values.country)
        formData.append('home_delivery', values.home_delivery)
        formData.append('order_amount', values.order_amount)
        formData.append('latitude', values.latitude)
        formData.append('longitude', values.longitude)
        formData.append('bank_account_number', values.bank_account_number)
        formData.append('bank_account_holder', values.bank_account_holder)
        formData.append('bank_name', values.bank_name)
        formData.append('bank_city', values.bank_city)
        formData.append('bank_ifsc', values.bank_ifsc)
        formData.append('bank_account_type', values.bank_account_type)
        
        formData.append('alt_mobile_number', values.alt_mobile_number)
        formData.append('alt_country_code', values.alt_country_code)
        formData.append('reg_certificate', values.upload_reg)
        formData.append('reg_date', values.reg_date)
        formData.append('reg_valid_upto', values.reg_valid_upto)
        formData.append('pharmacist_name', values.pharmacist_name)
        formData.append('course', data.course)
        formData.append('pharmacist_reg_number', values.pharmacist_reg_number)
        formData.append('issuing_authority', values.issuing_authority)
        formData.append('currency_code', values.currency_code)
        formData.append('payout_period', values.payout_period)


        EditData(formData)
        .then(items => {
          SuccessToast(items.data.message)
          props.loadSaveData()
          setLoading(false)
        })
        .catch(err => {
          ErrorToast(err)
          setLoading(false)
      })
      }
    });
    const onOpenDL = () => {
      window.open(formik.values.dl_file)
    }

    const onOpenRegCert = () => {
      window.open(formik.values.reg_certificate)
    }

    const changePincode = (event) => {
      const pincodeVal = event.target.value
      formik.setFieldValue("pincode", pincodeVal)
      getCode(pincodeVal, addr => {
        if (!addr) {
          return
        }
        if (addr.country){
          formik.setFieldValue("country", addr.country)
        } else {
          formik.setFieldValue("country", '')
        }
        if (addr.state){
          formik.setFieldValue("state", addr.state)
        } else {
          formik.setFieldValue("state", '')
        }
        if (addr.district){
          formik.setFieldValue("district", addr.district)
        } else {
          formik.setFieldValue("district", '')
        }
        if (addr.longitude){
          formik.setFieldValue("longitude", addr.longitude)
        }
        if (addr.latitude){
          formik.setFieldValue("latitude", addr.latitude)
        }
  
      })
    }

    const [dlData, setDlData] = React.useState('')


    let valueField = <p></p>
    if (formik.values.home_delivery === "1") {
        valueField = <div>
            
          <Select
            required
            style={{marginRight:"2%", marginBottom:"2%", width:"30%"}}
            name="currency_code"
            type="text"
            value={formik.values.currency_code}
            variant="outlined"
            onChange={formik.handleChange}
            >
              {
                currencyCodeData.map(
                  (item) => (
                  <MenuItem id={item.id} value={item.value}>{item.value}</MenuItem>
                  )
                )
              }
            </Select>
            <FormControl style={{width:'68%'}} variant="outlined" >
            <InputLabel htmlFor="outlined-adornment-amount">Minimum value of home delivery</InputLabel>
            <OutlinedInput
            required
                name="order_amount"
                type="number"
                value={formik.values.order_amount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                startAdornment={<InputAdornment position="start">{getSymbolFromCurrency(formik.values.currency_code)}</InputAdornment>}
                label='Minimum value of home delivery'
            />
            </FormControl>
        
            </div>
    } else if (formik.values.home_delivery === "0") {
      formik.values.order_amount = 0.00
        valueField = <p></p>
    }
        
    
    if (loading) {
      return (
        <Spinner />
      )
    }
      
    

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
      <h6 style={{marginTop:"2%", marginBottom:"2%"}} >Pharmacy Details</h6>
      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
          <TextField
            fullWidth
            required
            label="Pharmacy Name"
            name="pharmacy_name"
            type="text"
            value={formik.values.pharmacy_name}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.pharmacy_name && formik.touched.pharmacy_name && (
            <p style={{color:"red"}}>{formik.errors.pharmacy_name}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <Select
          disabled
            required
            style={{marginRight:"2%",  width:"33%"}}
            name="country_code"
            type="text"
            value={formik.values.country_code}
            variant="outlined"
            onChange={formik.handleChange}
            >
              {
                options.map(
                  (item) => (
                  <MenuItem id={item.id} value={item.value}>{item.label}</MenuItem>
                  )
                )
              }
            </Select>
            <FormControl style={{width:"65%"}} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-amount">Mobile<span>&nbsp;*</span></InputLabel>
            <OutlinedInput
          disabled
            required
          fullWidth
                name="mobile_number"
                type="number"
                value={formik.values.mobile_number}
                onChange={formik.handleChange}
                startAdornment={<InputAdornment position="start">{formik.values.country_code}</InputAdornment>}
                labelWidth={50}
                onBlur={formik.handleBlur}
            />
            {formik.errors.mobile_number && formik.touched.mobile_number && (
            <p style={{color:"red"}}>{formik.errors.mobile_number}</p>
             )}
            </FormControl>
        </Grid>
        <Grid item xs={4}>
        <TextField
          disabled
          fullWidth
          required
            label="Email ID"
            name="email"
            type="email"
            value={formik.values.email}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.email && formik.touched.email && (
            <p style={{color:"red"}}>{formik.errors.email}</p>
             )}
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={4}>
        <TextField
          fullWidth
          required
            // style={{margin:"2%", width:"200px"}}
            label="GSTN Number"
            name="gstin"
            type="text"
            value={formik.values.gstin}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.gstin && formik.touched.gstin && (
            <p style={{color:"red"}}>{formik.errors.gstin}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        </Grid>
        <Grid item xs={4}>
        </Grid>
        <Grid item xs={4}>
            
        </Grid>
      </Grid>
      <h6 style={{marginTop:"3%", marginBottom:"3%"}} >Drug License(DL)</h6>
      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        <TextField
          fullWidth
          required
            label="Drug Licence Number"
            name="dl_number"
            type="text"
            value={formik.values.dl_number}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.dl_number && formik.touched.dl_number && (
            <p style={{color:"red"}}>{formik.errors.dl_number}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
          fullWidth
          required
            label="Issuing Authority"
            name="dl_issuing_authority"
            type="text"
            value={formik.values.dl_issuing_authority}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.dl_issuing_authority && formik.touched.dl_issuing_authority && (
            <p style={{color:"red"}}>{formik.errors.dl_issuing_authority}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        {/* <TextField
          fullWidth
          required
            label="Date Of Issue"
            name="dl_date_of_issue"
            type="date"
            value={formik.values.dl_date_of_issue}
            variant="outlined"
            onChange={e => {
              if (new Date("9999-12-31") >= new Date(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            InputLabelProps={{
                shrink: true,
              }}
              onBlur={formik.handleBlur}
              />
              {formik.errors.dl_date_of_issue && formik.touched.dl_date_of_issue && (
              <p style={{color:"red"}}>{formik.errors.dl_date_of_issue}</p>
               )} */}

                   <DatePickerField 
                                mandatory
                                name="dl_date_of_issue"
                                label="Date Of Issue"
                                onChange={val => {
                                  formik.setFieldValue('dl_date_of_issue', String(val))
                                }}
                                onBlur={e => {
                                  formik.handleBlur(e);
                                }}
                                value={formik.values.dl_date_of_issue}
                                touched={formik.touched.dl_date_of_issue}
                                errors={formik.errors.dl_date_of_issue}
                                 />
        </Grid>
      </Grid>


      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        {/* <TextField
          fullWidth
          required
            label="Drug License Valid Upto"
            name="dl_valid_upto"
            type="date"
            value={formik.values.dl_valid_upto}
            variant="outlined"
            onChange={e => {
              if (new Date("9999-12-31") >= new Date(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            InputLabelProps={{
                shrink: true,
              }}
              onBlur={formik.handleBlur}
              />
              {formik.errors.dl_valid_upto && formik.touched.dl_valid_upto && (
              <p style={{color:"red"}}>{formik.errors.dl_valid_upto}</p>
               )} */}

                   <DatePickerField 
                                mandatory
                                name="dl_valid_upto"
                                label="Drug License Valid Upto"
                                onChange={val => {
                                  formik.setFieldValue('dl_valid_upto', String(val))
                                }}
                                onBlur={e => {
                                  formik.handleBlur(e);
                                }}
                                value={formik.values.dl_valid_upto}
                                touched={formik.touched.dl_valid_upto}
                                errors={formik.errors.dl_valid_upto}
                                 />
        </Grid>
        <Grid item xs={1}>
            {formik.values.dl_file && <IconButton
              color='primary'
              onClick={onOpenDL}>
              <VisibilityIcon />
            </IconButton>}
            
            {/* <ImageLoad image={formik.values.dl_file} style={{width:'50px', height:'50px', margin:'3%'}} /> */}
        </Grid>
        <Grid item xs={3}>
        <label >Upload Drug Licence</label>
          <FileUpload 
              name="upload_dl"
              onChange={value => {
                  formik.setFieldValue("upload_dl", value)
              }}
          onBlur={formik.handleBlur}
          />
        </Grid>
        <Grid item xs={4}>
        </Grid>
        <Grid item xs={4}>
        </Grid>
      </Grid>


      <h6 style={{marginTop:"2%", marginBottom:"2%"}} >Pharmacy Address</h6>
      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        <TextField
            fullWidth
            required
            label="Pincode"
            name="pincode"
            type="number"
            value={formik.values.pincode}
            variant="outlined"
            onChange={changePincode}
            // onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.pincode && formik.touched.pincode && (
            <p style={{color:"red"}}>{formik.errors.pincode}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
            fullWidth
            required
            label="Country"
            name="country"
            type="text"
            value={formik.values.country}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.country && formik.touched.country && (
            <p style={{color:"red"}}>{formik.errors.country}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
            fullWidth
            required
            label="State"
            name="state"
            type="text"
            value={formik.values.state}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.state && formik.touched.state && (
            <p style={{color:"red"}}>{formik.errors.state}</p>
             )}
        </Grid>
      </Grid>
      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        <TextField
            fullWidth
            required
            label="District"
            name="district"
            type="text"
            value={formik.values.district}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.district && formik.touched.district && (
            <p style={{color:"red"}}>{formik.errors.district}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
            fullWidth
            required
            label="City/Village/Society"
            name="city_village"
            type="text"
            value={formik.values.city_village}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.city_village && formik.touched.city_village && (
            <p style={{color:"red"}}>{formik.errors.city_village}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
            fullWidth
            required
            label="Area/Street/Sector"
            name="street_name"
            type="text"
            value={formik.values.street_name}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
              {formik.errors.street_name && formik.touched.street_name && (
              <p style={{color:"red"}}>{formik.errors.street_name}</p>
               )}
        </Grid>
      </Grid>

      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        <FormControl component="fieldset" 
            fullWidth>
            <FormLabel component="legend">Home Delivery</FormLabel>
            <RadioGroup row aria-label="home_delivery" name="home_delivery" value={formik.values.home_delivery} onChange={formik.handleChange}>
                <FormControlLabel value= "1" control={<Radio color="primary"  />} label="Yes" />
                <FormControlLabel value= "0" control={<Radio color="primary"  />} label="No" />
            </RadioGroup>
            </FormControl>
        </Grid>
        <Grid item xs={4}>
        {valueField}
        </Grid>
        <Grid item xs={4}>
        </Grid>
      </Grid>

      <h6 style={{marginTop:"2%", marginBottom:"2%"}} >Additional Details</h6>
      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        <TextField
          fullWidth
          required
            label="Name of Pharmacist"
            name="pharmacist_name"
            type="text"
            value={formik.values.pharmacist_name}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.pharmacist_name && formik.touched.pharmacist_name && (
            <p style={{color:"red"}}>{formik.errors.pharmacist_name}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <FormControl fullWidth variant="outlined" className={classes.formControl}>
          <InputLabel fullWidth htmlFor="outlined-age-native-simple">Course</InputLabel>
          <Select
          fullWidth
            value={formik.values.course}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="course"
            name="course"
          >
            <option value={'D.Pharm'}>D.Pharm</option>
            <option value={'B.Pharm'}>B.Pharm</option>
            <option value={'Pharm.D'}>Pharm.D</option>
            <option value={'Others'}>Others</option>
          </Select>
        </FormControl>
        {formik.values.course === 'Others' &&(
                <TextField
                style={{marginTop:'10px'}}
                fullWidth
                required
                  label="Course Name"
                  name="course_name"
                  type="text"
                  value={formik.values.course_name}
                  variant="outlined"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  />
                )}
                
                {formik.errors.course_name && formik.touched.course_name && (
                  <p style={{color:"red"}}>{formik.errors.course_name}</p>
                   )}
            {formik.errors.course && formik.touched.course && (
            <p style={{color:"red"}}>{formik.errors.course}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
          fullWidth
          required
            label="Registration Number of pharmacist"
            name="pharmacist_reg_number"
            type="text"
            value={formik.values.pharmacist_reg_number}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.pharmacist_reg_number && formik.touched.pharmacist_reg_number && (
            <p style={{color:"red"}}>{formik.errors.pharmacist_reg_number}</p>
             )}
        </Grid>
      </Grid>

      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        <TextField
          fullWidth
          required
            label="Issuing Authority"
            name="issuing_authority"
            type="text"
            value={formik.values.issuing_authority}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.issuing_authority && formik.touched.issuing_authority && (
            <p style={{color:"red"}}>{formik.errors.issuing_authority}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <Select
        required
            style={{marginRight:"2%", width:"33%"}}
            name="alt_country_code"
            type="text"
            value={formik.values.alt_country_code}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            >
              {
                options.map(
                  (item) => (
                  <MenuItem id={item.id} value={item.value}>{item.label}</MenuItem>
                  )
                )
              }
            </Select>
            <FormControl style={{width:"65%"}} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-amount">Alternative Number</InputLabel>
            <OutlinedInput
                name="alt_mobile_number"
                type="number"
                value={formik.values.alt_mobile_number}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                startAdornment={<InputAdornment position="start">{formik.values.alt_country_code}</InputAdornment>}
                labelWidth={130}
            />
            </FormControl>
            {formik.errors.alt_mobile_number && formik.touched.alt_mobile_number && (
            <p style={{color:"red"}}>{formik.errors.alt_mobile_number}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        {/* <TextField
          fullWidth
          required
            label="Registration date"
            name="reg_date"
            type="date"
            value={formik.values.reg_date}
            variant="outlined"
            onChange={e => {
              if (new Date("9999-12-31") >= new Date(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            onBlur={formik.handleBlur}
            InputLabelProps={{
                shrink: true,
              }}
            />
            {formik.errors.reg_date && formik.touched.reg_date && (
            <p style={{color:"red"}}>{formik.errors.reg_date}</p>
             )} */}

<DatePickerField 
                                mandatory
                                name="reg_date"
                                label="Registration date"
                                onChange={val => {
                                  formik.setFieldValue('reg_date', String(val))
                                }}
                                onBlur={e => {
                                  formik.handleBlur(e);
                                }}
                                value={formik.values.reg_date}
                                touched={formik.touched.reg_date}
                                errors={formik.errors.reg_date}
                                 />
        </Grid>
      </Grid>

      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        {/* <TextField
          fullWidth
          required
            label="Registration valid up to"
            name="reg_valid_upto"
            type="date"
            value={formik.values.reg_valid_upto}
            variant="outlined"
            onChange={e => {
              if (new Date("9999-12-31") >= new Date(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            onBlur={formik.handleBlur}
            InputLabelProps={{
                shrink: true,
              }}
            />
            {formik.errors.reg_valid_upto && formik.touched.reg_valid_upto && (
            <p style={{color:"red"}}>{formik.errors.reg_valid_upto}</p>
             )} */}

<DatePickerField 
                                mandatory
                                name="reg_valid_upto"
                                label="Registration valid up to"
                                onChange={val => {
                                  formik.setFieldValue('reg_valid_upto', String(val))
                                }}
                                onBlur={e => {
                                  formik.handleBlur(e);
                                }}
                                value={formik.values.reg_valid_upto}
                                touched={formik.touched.reg_valid_upto}
                                errors={formik.errors.reg_valid_upto}
                                 />
        
        </Grid>
        <Grid item xs={1}>
            {/* <IconButton
              color='primary'
              onClick={onOpenRegCert}>
              <VisibilityIcon />
            </IconButton> */}
            <ImageLoad image={formik.values.reg_certificate} style={{width:'50px', height:'50px', margin:'3%'}} />
        
        </Grid>
        <Grid item xs={3}>
        <label >Upload Registration Certification</label>
          <FileUpload 
              name="upload_reg"
              onChange={value => {
                  formik.setFieldValue("upload_reg", value)
              }}
          onBlur={formik.handleBlur}
          />
        </Grid>
        <Grid item xs={4}>
        </Grid>
      </Grid>

      
      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}><Grid item xs={4}>
        <FormControl fullWidth variant="outlined" className={classes.formControl}>
          <InputLabel fullWidth htmlFor="outlined-age-native-simple">Payout Period</InputLabel>
          <Select
          fullWidth
            value={formik.values.payout_period}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="payout_period"
            name="payout_period"
          >
            <option value={0}>Monthly</option>
            <option value={1}>Weekly</option>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
      
      
      <h6 style={{marginTop:"2%", marginBottom:"2%"}} >Banking Details</h6>
      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        <TextField
          fullWidth
          
            label="Bank Account Number"
            name="bank_account_number"
            type="text"
            value={formik.values.bank_account_number}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.bank_account_number && formik.touched.bank_account_number && (
            <p style={{color:"red"}}>{formik.errors.bank_account_number}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
          fullWidth
          
            label="Account Holder Full Name"
            name="bank_account_holder"
            type="text"
            value={formik.values.bank_account_holder}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.bank_account_holder && formik.touched.bank_account_holder && (
            <p style={{color:"red"}}>{formik.errors.bank_account_holder}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
          fullWidth
          
            label="Bank Name"
            name="bank_name"
            type="text"
            value={formik.values.bank_name}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.bank_name && formik.touched.bank_name && (
            <p style={{color:"red"}}>{formik.errors.bank_name}</p>
             )}
        </Grid>
      </Grid>

      <Grid container spacing={3} style={{marginBottom:"2%", marginTop:"2%"}}>
        <Grid item xs={4}>
        <TextField
          fullWidth
          
            label="Bank City"
            name="bank_city"
            type="text"
            value={formik.values.bank_city}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            {formik.errors.bank_city && formik.touched.bank_city && (
            <p style={{color:"red"}}>{formik.errors.bank_city}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <TextField
          fullWidth
          
            label="Bank IFSC Code"
            name="bank_ifsc"
            type="text"
            value={formik.values.bank_ifsc}
            variant="outlined"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            
            {formik.errors.bank_ifsc && formik.touched.bank_ifsc && (
            <p style={{color:"red"}}>{formik.errors.bank_ifsc}</p>
             )}
        </Grid>
        <Grid item xs={4}>
        <FormControl fullWidth variant="outlined" className={classes.formControl}>
        <InputLabel fullWidth htmlFor="outlined-age-native-simple">Account Type</InputLabel>
        <Select
        fullWidth
          value={formik.values.bank_account_type}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label="Account Type"
          name="bank_account_type"
        >
          <option value={'CURRENT'}>CURRENT</option>
          <option value={'SAVINGS'}>SAVINGS</option>
          <option value={'SALARY'}>SALARY</option>
          <option value={'FIXED DEPOSIT'}>FIXED DEPOSIT</option>
          <option value={'RECURRING DEPOSIT'}>RECURRING DEPOSIT</option>
          <option value={'NRI'}>NRI</option>
          <option value={'NRO'}>NRO</option>
          <option value={'NRE'}>NRE</option>
          <option value={'FCNR'}>FCNR</option>
        </Select>
      </FormControl>
            {formik.errors.bank_account_type && formik.touched.bank_account_type && (
            <p style={{color:"red"}}>{formik.errors.bank_account_type}</p>
             )}
        </Grid>
      </Grid>
      <button
            type="submit"
            style={{ display: "none" }}
            ref={props.btnRef}
        ></button>
      </form>
            
    </div>
  );
}
